import Script from 'next/script';

import _ from 'lodash';

import { LOCALIZE_PROJECT_KEY } from '@/constants/env';
import { useAppSelector } from '@/redux/hooks';

export default function LocalizeScript({ nonce }: { nonce: string }) {
  const companyLocalizeProjectKey = useAppSelector((state) => state.auth.companyAccount?.localize_project_id);
  const companyCustomizations = useAppSelector((state) => state.auth.companyAccount?.customization_uid);

  const localizeApiKey = companyLocalizeProjectKey || LOCALIZE_PROJECT_KEY;

  if (!localizeApiKey) {
    return null;
  }

  return (
    <Script
      id="localize"
      nonce={nonce}
      src="https://global.localizecdn.com/localize.js"
      onLoad={() => {
        (function (a: any) {
          if (!a.Localize) {
            a.Localize = {};
            for (
              var e = [
                  'translate',
                  'untranslate',
                  'phrase',
                  'initialize',
                  'translatePage',
                  'setLanguage',
                  'getLanguage',
                  'getSourceLanguage',
                  'detectLanguage',
                  'getAvailableLanguages',
                  'untranslatePage',
                  'bootstrap',
                  'prefetch',
                  'on',
                  'off',
                  'hideWidget',
                  'showWidget',
                ],
                t = 0;
              t < e.length;
              t++
            )
              a.Localize[e[t]] = function () {};
          }
        })(window);

        (window as any).Localize.initialize({
          key: localizeApiKey,
          rememberLanguage: true,
          autoApprove: true,
          blockedClasses: ['mbsy-do-not-translate'],
        });

        const defaultLanguage = companyCustomizations?.default_language_uid.code;

        const availableLanguages = [
          ...(defaultLanguage ? [defaultLanguage] : []),
          ...(companyCustomizations?.auto_translate_languages
            .filter(({ status }) => status === 'approved')
            .map((lang) => lang.language_uid.code) || []),
        ];

        (window as any).Localize.detectLanguage({ closestAvailableLanguages: true }, (__err: Error, languages: string[]) => {
          //find highest prioritized user language that is also enabled and set it as language
          var languagesOverlap = _.intersection(languages, availableLanguages);

          if (languagesOverlap[0] === defaultLanguage || languagesOverlap.length === 0) {
            (window as any).Localize.untranslatePage();
            return;
          }

          (window as any).Localize.setLanguage(languagesOverlap[0]);
        });
      }}
      defer
    />
  );
}
